// generated from 4_437_289 samples

import { z } from "zod";
import { androidPushMessageGetSchema } from "./androidPushMessageGetSchema";
import { bannerMessageGetSchema } from "./bannerMessageGetSchema";
import { contentCardMessageGetSchema } from "./contentCardMessageGetSchema";
import { controlMessageGetSchema } from "./controlMessageGetSchema";
import { emailMessageGetSchema } from "./emailMessageGetSchema";
import { featureFlagExperimentMessageGetSchema } from "./featureFlagExperimentMessageGetSchema";
import { iosPushMessageGetSchema } from "./iosPushMessageGetSchema";
import { kakaoMessageGetSchema } from "./kakaoMessageGetSchema";
import { kindlePushMessageGetSchema } from "./kindlePushMessageGetSchema";
import { lineMessageGetSchema } from "./lineMessageGetSchema";
import { smsMessageGetSchema } from "./smsMessageGetSchema";
import { triggerMessageGetSchema } from "./triggerMessageGetSchema";
import { webPushMessageGetSchema } from "./webPushMessageGetSchema";
import { webhookMessageGetSchema } from "./webhookMessageGetSchema";
import { whatsAppMessageGetSchema } from "./whatsAppMessageGetSchema";

export const messageGetSchema = z.discriminatedUnion("message_type", [
  androidPushMessageGetSchema,
  bannerMessageGetSchema,
  contentCardMessageGetSchema,
  controlMessageGetSchema,
  emailMessageGetSchema,
  featureFlagExperimentMessageGetSchema,
  iosPushMessageGetSchema,
  kakaoMessageGetSchema,
  kindlePushMessageGetSchema,
  lineMessageGetSchema,
  smsMessageGetSchema,
  triggerMessageGetSchema,
  webPushMessageGetSchema,
  webhookMessageGetSchema,
  whatsAppMessageGetSchema,
]);
